// import Vue from "vue";
// // 监听el-table滚动
// Vue.directive("loadmore", {
//   bind(el, binding) {
//     console.log("el, binding", el, binding);
//     const selectWrap = el.querySelector(".el-table__body-wrapper");
//     selectWrap.addEventListener("scroll", function() {
//       let sign = 0;
//       const scrollDistance =
//         this.scrollHeight - this.scrollTop - this.clientHeight - 1;
//       console.log(scrollDistance);
//       if (scrollDistance <= sign) {
//         binding.value();
//       }
//     });
//   }
// });

import Vue from "vue";

// //全局自定义指令
// Vue.directive("loadmore", {
//   bind(el, binding) {
//     const selectWrap = el.querySelector(".el-table__body-wrapper");
//     selectWrap.addEventListener("scroll", function() {
//       let sign = 200;
//       const scrollDistance =
//         this.scrollHeight - this.scrollTop - this.clientHeight;
//       if (Math.ceil(scrollDistance) <= sign) {
//         binding.value();
//       }
//     });
//   }
// });

//全局自定义指令
Vue.directive("loadmore", {
  bind(el, binding) {
    console.log(el, binding);
    // 获取当前滚动的节点，注意必须要有高度
    const selectWrap = el.querySelector(".el-table__body-wrapper");
    console.log("selectWrap", selectWrap);
    if (selectWrap) {
      selectWrap.addEventListener("scroll", function(e) {
        let sign = 3; // 这个sign值，只是为了滚动到最底部3px的时候加载
        const scrollDistance =
          this.scrollHeight - this.scrollTop - this.clientHeight;
        console.log("scrollDistance", scrollDistance);
        if (Math.ceil(scrollDistance) <= sign) {
          // 到这里 就会执行方法了
          console.log("执行");
          binding.value();
        }
      });
    } else {
      console.log("没找到元素");
    }
  }
});



// WEBPACK FOOTER //
// ./src/utils/directives.js